import { render, staticRenderFns } from "./KnowledgeUnitTally.vue?vue&type=template&id=0ee2244c&"
import script from "./KnowledgeUnitTally.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitTally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports